/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import PropTypes from 'prop-types';

import { Spacer, Heading, Loading } from 'school-space-client/components';

import ReviewStartEndDates from '../components/sections/rebooking/bookingConfirmation/ReviewStartEndDates';
import ReviewSpaces from '../components/sections/rebooking/bookingConfirmation/ReviewSpaces';
import ReviewIndividualDates from '../components/sections/rebooking/bookingConfirmation/ReviewIndividualDates';

const css = {
    titleRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
};

const ProspectiveRecurringBooking = ({ recurringBooking, refetchBooking, stepIndex, nextStep }) => {
    return (
        <main>
            <div css={css.titleRow}>
                <Heading level="1" size="x-large">
                    Repeat booking
                </Heading>
            </div>
            <Spacer height={2} />
            {recurringBooking ? (
                <React.Fragment>
                    <ReviewStartEndDates
                        recurringBooking={recurringBooking}
                        refetchBooking={refetchBooking}
                        confirmStep={nextStep}
                        stepIsConfirmed={stepIndex > 0}
                    />
                    <ReviewSpaces
                        recurringBooking={recurringBooking}
                        refetchBooking={refetchBooking}
                        confirmStep={nextStep}
                        stepIsConfirmed={stepIndex > 1}
                        stepIsVisible={stepIndex > 0}
                    />
                    <ReviewIndividualDates
                        recurringBooking={recurringBooking}
                        refetchBooking={refetchBooking}
                        confirmStep={nextStep}
                        stepIsConfirmed={stepIndex > 2}
                        stepIsVisible={stepIndex > 1}
                    />
                </React.Fragment>
            ) : (
                <Loading />
            )}
        </main>
    );
};

ProspectiveRecurringBooking.propTypes = {
    recurringBooking: PropTypes.objectOf(PropTypes.any).isRequired,
    refetchBooking: PropTypes.func.isRequired,
    stepIndex: PropTypes.number.isRequired,
    nextStep: PropTypes.func.isRequired
};

export default ProspectiveRecurringBooking;
